export default __webpack_public_path__ + "static/media/home-travel-agency-about.619dca05.jpg";